import { RENTER_STATUS } from "./renter.type";

export type ICommission = {
  _id?: string;
  typeCommission?: COMMISSION_TYPE;
  paymentId?: string;
  customerId?: string;
  firstPaymentSubscription?: string | null;
  dueDate?: string;
  status?: string | string[];
  renterId?: string;
  renterName?: string;
  renterStatus?: RENTER_STATUS;
  technicalConsultant?: string;
  consultantTotal?: string;
  sdr?: string;
  licensePlate?: string;
  activationDate?: Date;
  currentContractStartDate?: Date;
}

export enum COMMISSION_TYPE {
  ACTIVATION = "activation",
  RENEWPLAN = "renew",
  ACTIVATION_PLUS = "activation-plus",
  RENEWPLAN_PLUS = "renew-plus",
  PLUS = 'plus',
  UNDEFINED = "undefined"
}


export const emptyTechnicalConsultant = (): ICommission[] => [{
  _id: "",
  typeCommission: COMMISSION_TYPE.UNDEFINED,
  paymentId: "",
  customerId: "",
  firstPaymentSubscription: "",
  dueDate: "",
  status: [],
  renterId: "",
  renterName: "",
  renterStatus: RENTER_STATUS.Indefinido,
  technicalConsultant: "",
  sdr: "",
  licensePlate: "",
  activationDate: new Date(),
  currentContractStartDate: new Date(),
}];